import React, { useEffect } from 'react';
import { Stack, Typography } from '@mui/material';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import { BANK, CARD } from '../../constants/common';
import EastIcon from '@mui/icons-material/East';
import { StyledNewPaymentMethodItem } from './AddNewPaymentMethodStyles';

const PaymentMethods = [
  {
    label: 'Add New Card',
    type: CARD,
    icon: CreditCardOutlinedIcon,
  },
  {
    label: 'Add New Bank Account',
    type: BANK,
    icon: AccountBalanceOutlinedIcon,
  },
];
interface IPaymentMethodsListProps {
  onSelect: (type: string) => void;
  emitHeight: () => void;
}
const PaymentMethodsList = ({ onSelect, emitHeight }: IPaymentMethodsListProps) => {
  useEffect(() => {
    emitHeight();
  }, []);

  return (
    <Stack spacing={8}>
      <>
        {PaymentMethods.map((paymentMethod) => {
          const MethodIcon = paymentMethod.icon;
          return (
            <StyledNewPaymentMethodItem
              key={paymentMethod?.type}
              onClick={() => onSelect(paymentMethod.type)}
            >
              <div className='payment-type'>
                <MethodIcon color='primary' sx={{ mr: 4 }} />
                <Typography variant='h6' color='primary'>
                  {paymentMethod?.label}
                </Typography>
              </div>
              <EastIcon color='primary' />
            </StyledNewPaymentMethodItem>
          );
        })}
      </>
    </Stack>
  );
};

export default PaymentMethodsList;
